import React, { Suspense, lazy } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { SELECT_QUESTION_TYPES, QUESTION_TYPES_WITH_OPT_OUT, QUESTION_TYPE_MAP } from 'utils/constants'
import { Input, Loader } from 'components/UIElements'

const ChoicesList = lazy(() => import(/* webpackChunkName: "dnd-kit-survey" */ './ChoicesList'))
import LongListSelectOneTextarea from './LongList/LongListSelectOneTextarea'
import { selectViewActions } from '../modules/Survey'
import STRINGS from 'utils/strings'

const OPT_OUT_LABEL_MAX_LENGTH = 100

class SelectView extends React.Component {
  componentDidUpdate(prevProps) {
    const { item } = this.props
    if (prevProps.item.type !== item.type) {
      if (!SELECT_QUESTION_TYPES.includes(item.type)) {
        this.el?.querySelector('textarea')?.focus()
      }
    }
  }

  shouldCancelStart = e => {
    const { isActive } = this.props
    return !isActive || !e.target.className.includes('choice-grab-icon')
  }

  updateLabel = type => value => {
    const { updateItem, item, itemId } = this.props
    let newItem
    if (type === 'opt_out') {
      newItem = { ...item, attributes: { ...item.attributes, opt_out: value } }
      updateItem(itemId, newItem)
    }
  }

  onAddChoice = idx => {
    const { item, addChoice, itemId } = this.props
    return () => {
      addChoice(itemId, item.choices_order.length, idx, item.type)
    }
  }

  render() {
    const { itemId, moveChoice, item, errors, preview } = this.props
    const isLongList = item.type === 'long_list_select_one'
    const { attributes } = item
    const { opt_out, hasOptOut } = attributes
    const canHaveOptOut = QUESTION_TYPES_WITH_OPT_OUT.includes(item.type) && hasOptOut
    return (
      <div
        ref={el => {
          this.el = el
        }}
        className='multi-choice-container'>
        {errors && !!errors.valuesErr && <p className='survey-error nrs-value'>{errors.valuesErr}</p>}
        {errors && !!errors.blankValuesErr && <p className='survey-error nrs-value'>{errors.blankValuesErr}</p>}
        {isLongList ? (
          <LongListSelectOneTextarea {...this.props} />
        ) : (
          <Suspense fallback={<div className='flexed center-justified' style={{ minHeight: 60 }}><Loader inContainer size={20} /></div>}>
            <ChoicesList
              onSortEnd={({ oldIndex, newIndex }) => moveChoice(itemId, oldIndex, newIndex)}
              lockAxis={
                item.type === 'likert' ||
                  item.type === 'numeric_rating_scale' ||
                  item.type === QUESTION_TYPE_MAP.horizontalSelectOne
                  ? 'x'
                  : 'y'
              }
              axis={
                item.type === 'likert' ||
                  item.type === 'numeric_rating_scale' ||
                  item.type === QUESTION_TYPE_MAP.horizontalSelectOne
                  ? 'x'
                  : 'y'
              }
              lockToContainerEdges
              helperClass='sortableHelper choices'
              shouldCancelStart={this.shouldCancelStart}
              onAddChoice={this.onAddChoice}
              {...this.props}
            />
          </Suspense>
        )}
        {canHaveOptOut ? (
          <Input
            placeholder={STRINGS.surveyNRSOptOutPlaceholder}
            disabled={preview}
            className='opt-out-label-input'
            value={opt_out || ''}
            charLimit={!preview ? OPT_OUT_LABEL_MAX_LENGTH : null}
            onChange={this.updateLabel('opt_out')}
            label={STRINGS.optOut}
            hasError={!opt_out && errors?.blankOptOutErr}
          />
        ) : null}
      </div>
    )
  }
}

export default connect(null, selectViewActions)(SelectView)

SelectView.propTypes = {
  item: PropTypes.object,
  errors: PropTypes.object,
  itemId: PropTypes.string,
  moveChoice: PropTypes.func,
  addChoice: PropTypes.func,
  isActive: PropTypes.bool,
  preview: PropTypes.bool,
}
